module.exports = __webpack_public_path__ + "static/img/18.0f83d84.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/18.png
// module id = sr0G
// module chunks = 0